import { render } from "./MoonData.vue?vue&type=template&id=4e1e3947&scoped=true&ts=true"
import script from "./MoonData.vue?vue&type=script&lang=ts"
export * from "./MoonData.vue?vue&type=script&lang=ts"

import "./MoonData.vue?vue&type=style&index=0&id=4e1e3947&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1e3947"]])

export default __exports__